import * as React from 'react';
import * as classnames from 'classnames';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { Button } from 'elc-buttons';
import { ContentSpacing } from 'elc-base-theme';

export interface IShopNowButton {
    label: string;
    productUrl: string;
    onShopNowClick(productUrl: string): void;
}

const StyledAnchor = styled(Button)`
    width: 100%;
    margin-right: ${ContentSpacing.space16};
    height: 40px;

    [dir='rtl'] & {
        margin-left: ${ContentSpacing.space16};
        margin-right: 0;
    }
`;

export const ShopNowButton = observer((props: IShopNowButton) => {
    const ShopNowButtonClassNames = classnames('elc-shop-now-button', 'js-shop-now-button');

    const onShopNowClick = () => {
        props.onShopNowClick(props.productUrl);
    };

    return (
        <StyledAnchor className={ShopNowButtonClassNames} onClick={onShopNowClick}>
            {props.label}
        </StyledAnchor>
    );
});
